import { Image } from "~/ui-rtk/components/ui/common/Image"
import { cn } from "~/ui-rtk/utils/tailwind-utils"
import type { BlastSource } from "./types"

function getSectionLabel(source: BlastSource): string {
  switch (source.type) {
    case "ad":
      return "SELECTED AD"
    case "post":
      return "SELECTED POST"
    case "creative":
      return "SELECTED CREATIVE"
  }
}

function getTitle(source: BlastSource): string {
  return source.name || (source.type === "post" ? "Organic post" : "Creative")
}

function getSubtitle(source: BlastSource): string {
  switch (source.type) {
    case "ad":
      return `${source.mediaChannel || source.platform} Ad`
    case "post":
      return `${source.mediaChannel || source.platform} Post${source.postId ? ` • ID: ${source.postId.substring(0, 15)}...` : ""}`
    case "creative":
      return `${source.mediaChannel || source.platform} Creative`
  }
}

interface SourcePreviewProps {
  source: BlastSource
  isDemoEnabled?: boolean
}

export default function SourcePreview({
  source,
  isDemoEnabled = false,
}: SourcePreviewProps) {
  const title = getTitle(source)
  const subtitle = getSubtitle(source)

  return (
    <div className="mb-6 pb-4 border-b-2 border-system-blue-600">
      <h6 className="text-gray-400 text-sm font-medium mb-3 uppercase tracking-wide text-left">
        {getSectionLabel(source)}
      </h6>
      <div className="flex gap-4 items-start">
        <div className="flex-shrink-0">
          <Image
            classes={{
              image: isDemoEnabled ? "blur-md" : "",
              wrapper: cn(
                "w-16 h-16 rounded-lg overflow-hidden",
                isDemoEnabled && "blur-md",
              ),
            }}
            src={source.imageUrl ?? ""}
            alt={title}
          />
        </div>
        <div className="flex-1">
          <p
            className={cn(
              "text-white font-medium line-clamp-2",
              isDemoEnabled && "blur-md",
            )}
          >
            {title}
          </p>
          <p className="text-gray-400 text-sm mt-1 capitalize">{subtitle}</p>
        </div>
      </div>
    </div>
  )
}
